import { EventPayload } from '@chronosphereio/core';

export const SAVED_VIEW_EVENTS = {
  SELECTED: 'saved_view_selected',
  CREATED: 'saved_view_created',
  UPDATED: 'saved_view_updated',
  DELETED: 'saved_view_deleted',
  PREVIOUS_DEFAULT_RESOLVED: 'saved_view_previous_default_resolved',
} as const;

export const SAVED_VIEW_SOURCE = {
  SELECTOR: 'selector',
  DIALOG: 'dialog',
} as const;

export function savedViewPayload(base?: EventPayload, extra?: EventPayload): EventPayload {
  return { ...base, ...extra };
}
